import { Link, Typography } from '@mui/material';
import { MprcContainer } from 'components';
import { FeedItemDto, PublicationType, UserItemDtoPaginatedList } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ListUsersDrawer } from 'views/foundation/user/drawers/ListUsersDrawer';

////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publication: FeedItemDto;
}

////////////////////////////////////////////////////////////////////////////////////////////////

export const PublicationViewsBox: React.FC<IProps> = ({ publication }) => {
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");
    const [dialog, setDialog] = useState<any>();

    ///
    const handleViewFollowingList = () => {
        setDialog(
            <ListUsersDrawer
                onGetData={({ searchText, pageNumber, pageSize }, signal) =>
                    new Promise<UserItemDtoPaginatedList>((resolve, reject) => {
                        api.v1.knowledgePublication.getPublicationFollowers({ publicationId: publication.publicationId, searchText: searchText, pageNumber: pageNumber, pageSize: pageSize }, { signal })
                            .then(result => resolve(result.data))
                            .catch(e => reject(e));
                    })}
                onClose={() => setDialog(null)}
            />
        );
    };

    return (
        <>
            {dialog}
            {
                publication.publicationType == PublicationType.List
                    ? <>
                        <MprcContainer margin="dense">
                            <Typography variant="h3">{t("Publication.ContentPage.InfoSubTitle")}</Typography>
                        </MprcContainer>
                        {/* <Typography variant="body2" sx={{ textTransform: "uppercase" }}>{t("Publication.CotentPage.ListItemsCountText", { count: 0 })}</Typography> */}
                        <Typography variant="subtitle1">{t("Publication.ContentPage.PublicationCountText", { count: publication.listDefinition?.itemCount ?? 0 })}</Typography>
                        {publication.listDefinition?.isPublic == true &&
                            <>
                                <Typography variant="subtitle1">{t("Publication.ContentPage.ViewCountText", { count: publication.otherInfo.viewCount ?? 0 })}</Typography>
                                <Typography variant="subtitle1">
                                    <Link variant="inherit" fontSize="inherit" onClick={(publication.listDefinition?.followersCount ?? 0) > 0 ? handleViewFollowingList : undefined}>
                                        {t("Publication.ContentPage.PeopleFollowingCountText", { count: publication.listDefinition?.followersCount ?? 0 })}
                                    </Link>
                                    <span>{" "}  {t("Publication.ContentPage.FollowingText")}</span>
                                </Typography>

                            </>
                        }
                    </>
                    : <>
                        <MprcContainer margin="dense">
                            <Typography variant="h3">{t("Publication.ContentPage.ViewsSubtitle")}</Typography>
                        </MprcContainer>
                        <Typography variant="subtitle1">{t("Publication.ContentPage.ViewCountText", { count: publication.otherInfo.viewCount ?? 0 })}</Typography>
                    </>
            }
        </>
    );
};
